"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var javascript_sdk_1 = require("@mdap/javascript-sdk");
var log_1 = require("@mdap/javascript-sdk/lib/utils/log");
var isAPIResource = function isAPIResource(entry) {
  return entry.entryType === 'resource' && ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
};
var supportObserveType = function supportObserveType(type) {
  var _a, _b;
  return (_b = (_a = window.PerformanceObserver) === null || _a === void 0 ? void 0 : _a.supportedEntryTypes) === null || _b === void 0 ? void 0 : _b.includes(type);
};
var supportGetEntriesByType = typeof ((_a = window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType) === 'function';
var RequiredValues = ['duration', 'connectEnd', 'connectStart', 'responseStart', 'responseEnd', 'requestStart'];
/** 上报数据预校验 - 校验非空的值, 丢弃无用数据 */
var isDataValid = function isDataValid(entry) {
  for (var _i = 0, RequiredValues_1 = RequiredValues; _i < RequiredValues_1.length; _i++) {
    var key = RequiredValues_1[_i];
    if (!entry[key]) {
      return false;
    }
  }
  return true;
};
// 去除query, 添加域名
var formatUrl = function formatUrl(url) {
  var result = url.replace(/(\?\w+?=.*$)/, '');
  if (!/^http/.test(url)) {
    result = window.location.origin + result;
  }
  return result;
};
var DEFAULT_LOGIC_STATUS_CODE = 0;
var isMatchArray = function isMatchArray(config) {
  return typeof config === 'object';
};
var isRequestObject = function isRequestObject(info) {
  return typeof window.fetch === 'function' && info instanceof Request;
};
var APIPlugin = /** @class */function (_super) {
  __extends(APIPlugin, _super);
  function APIPlugin() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.type = 'api';
    _this.originalDatas = {};
    _this.host = '';
    return _this;
  }
  APIPlugin.prototype.isMatch = function (url) {
    if (typeof url !== 'string') {
      return false;
    }
    // skip上报接口
    if (this.host && (url === null || url === void 0 ? void 0 : url.match(this.host))) {
      return false;
    }
    if (!this.configs.path) {
      return true;
    }
    if (isMatchArray(this.configs.path)) {
      var matched = false;
      for (var _i = 0, _a = this.configs.path; _i < _a.length; _i++) {
        var rule = _a[_i];
        if (url.match(rule)) {
          matched = true;
          break;
        }
      }
      return matched;
    } else {
      return !!url.match(this.configs.path);
    }
  };
  APIPlugin.trackData = function (data) {
    if (typeof data.url !== 'string') {
      return;
    }
    for (var _i = 0, _a = Object.values(APIPlugin.TRIGGER_MAPS); _i < _a.length; _i++) {
      var triggerConfig = _a[_i];
      if (triggerConfig.match(data.url)) {
        // 分发给实例的trigger
        triggerConfig.triggerFunction(__assign(__assign({}, data), {
          url: formatUrl(data.url)
        }));
      }
    }
  };
  APIPlugin.prototype.setLogicStatus = function (id, logicStatus) {
    var data = this.originalDatas[id];
    if (data && this.triggerHandler) {
      var reportData = __assign(__assign({}, data), {
        logic_status_code: logicStatus
      });
      this.triggerHandler(reportData);
      delete this.originalDatas[id];
    }
  };
  APIPlugin.prototype.checkData = function () {
    if (Object.keys(this.originalDatas).length > 30) {
      console.warn('Check if you forgot to call apiPlugin.setLogicStatus() with useLogicStatus is true.');
      // release
      this.originalDatas = {};
    }
  };
  APIPlugin.prototype.register = function (props) {
    var _this = this;
    // 
    this.triggerHandler = props.trigger;
    this.host = javascript_sdk_1.host[props.env];
    var addData = function addData(data) {
      _this.checkData();
      var dataId = data.dataId,
        type = data.type,
        restData = __rest(data, ["dataId", "type"]);
      // xhr abort 
      var tiggerImmediately = !_this.configs.useLogicStatus || type === 'xhr' && restData.http_status_code === 0;
      if (tiggerImmediately) {
        props.trigger(restData);
      } else {
        _this.originalDatas[dataId] = restData;
      }
    };
    APIPlugin.TRIGGER_MAPS[props.app_name] = {
      match: this.isMatch.bind(this),
      triggerFunction: addData
    };
    this.init();
  };
  APIPlugin.prototype.unregister = function (app_name) {
    delete APIPlugin.TRIGGER_MAPS[app_name];
    this.triggerHandler = function () {
      //
    };
  };
  /** override fetch / xhr */
  APIPlugin.prototype.init = function () {
    try {
      this.handleLoadedResource();
      this.observe();
      if (APIPlugin.filled) {
        return;
      }
      this.trackXHR();
      this.trackFetch();
      APIPlugin.filled = true;
    } catch (error) {
      console.log('Failed to init mdap api plugin');
      console.error(error);
    }
  };
  // xhr
  APIPlugin.prototype.trackXHR = function () {
    //
    var originalSend = XMLHttpRequest.prototype.send;
    var originalOpen = XMLHttpRequest.prototype.open;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    XMLHttpRequest.prototype.open = function () {
      var _this = this;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      this.addEventListener('readystatechange', function () {
        var _a;
        if (_this.readyState === XMLHttpRequest.DONE) {
          var endTimeStamp = +new Date();
          /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion,@typescript-eslint/no-non-null-asserted-optional-chain */
          var startTimeStamp = (_a = _this._MDAP_DATA_) === null || _a === void 0 ? void 0 : _a.startTimestamp;
          _this._MDAP_DATA_ID_ = endTimeStamp.toString();
          APIPlugin.trackData({
            start_timestamp: startTimeStamp,
            end_timestamp: endTimeStamp,
            url: args[1],
            page_url: "" + window.location.origin + window.location.pathname,
            duration: endTimeStamp - startTimeStamp,
            http_method: args[0],
            http_status_code: _this.status,
            logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
            dataId: endTimeStamp.toString(),
            type: 'xhr'
          });
        }
      });
      return originalOpen.apply(this, args);
    };
    XMLHttpRequest.prototype.send = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      this._MDAP_DATA_ = {
        startTimestamp: +new Date()
      };
      return originalSend.apply(this, args);
    };
  };
  // fetch 
  APIPlugin.prototype.trackFetch = function () {
    if (typeof window.fetch !== 'function') {
      return;
    }
    var originalFetch = window.fetch;
    window.fetch = function (info, init) {
      var startTimestamp = +new Date();
      var triggerTrack = function triggerTrack(response) {
        var _a, _b;
        var endTimeStamp = +new Date();
        if (response) {
          response._MDAP_DATA_ID_ = endTimeStamp.toString();
        }
        if (isRequestObject(info)) {
          APIPlugin.trackData({
            start_timestamp: startTimestamp,
            end_timestamp: endTimeStamp,
            duration: endTimeStamp - startTimestamp,
            url: info.url,
            page_url: "" + window.location.origin + window.location.pathname,
            http_method: info['method'] || 'GET',
            http_status_code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : 0,
            http_referer: info.referrer,
            logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
            dataId: endTimeStamp.toString(),
            type: 'fetch'
          });
        } else {
          APIPlugin.trackData({
            start_timestamp: startTimestamp,
            end_timestamp: endTimeStamp,
            duration: endTimeStamp - startTimestamp,
            url: info,
            page_url: "" + window.location.origin + window.location.pathname,
            http_method: (init === null || init === void 0 ? void 0 : init['method']) || 'GET',
            http_status_code: (_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 0,
            http_referer: init === null || init === void 0 ? void 0 : init.referrer,
            logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
            dataId: endTimeStamp.toString(),
            type: 'fetch'
          });
        }
      };
      var onResolve = function onResolve(response) {
        triggerTrack(response);
        return response;
      };
      var onReject = function onReject(error) {
        triggerTrack(undefined);
        return Promise.reject(error);
      };
      return originalFetch.call(window, info, init).then(onResolve, onReject);
    };
  };
  /** API TIMING */
  APIPlugin.prototype.handleTiming = function (entry) {
    if (!isAPIResource(entry)) {
      return;
    }
    if (!this.isMatch(entry.name) || !this.triggerHandler) {
      return;
    }
    if (!isDataValid(entry)) {
      return;
    }
    var timeOrigin = performance.timeOrigin || performance.timing.navigationStart;
    this.triggerHandler({
      url: formatUrl(entry.name),
      page_url: "" + window.location.origin + window.location.pathname,
      event_timestamp: Math.round(timeOrigin),
      start_time: Math.round(entry.startTime),
      duration: Math.round(entry.duration),
      connect_start: Math.round(entry.connectStart),
      connect_end: Math.round(entry.connectEnd),
      domain_lookup_start: Math.round(entry.domainLookupStart),
      domain_lookup_end: Math.round(entry.domainLookupEnd),
      redirect_start: Math.round(entry.redirectStart),
      redirect_end: Math.round(entry.redirectEnd),
      request_start: Math.round(entry.requestStart),
      response_start: Math.round(entry.responseStart),
      response_end: Math.round(entry.responseEnd),
      worker_start: Math.round(entry.workerStart),
      fetch_start: Math.round(entry.fetchStart),
      secure_connection_start: Math.round(entry.secureConnectionStart)
    });
  };
  APIPlugin.prototype.handleLoadedResource = function () {
    var _this = this;
    if (supportGetEntriesByType) {
      performance.getEntriesByType('resource').map(function (entry) {
        _this.handleTiming(entry);
      });
    }
  };
  APIPlugin.prototype.observe = function () {
    var _this = this;
    // 
    if (!supportObserveType('resource')) {
      return;
    }
    this.po = new PerformanceObserver(function (list) {
      return list.getEntries().map(_this.handleTiming.bind(_this));
    });
    this.po.observe({
      entryTypes: ['resource']
    });
  };
  APIPlugin.prototype.disconnectObserve = function () {
    var _a;
    (_a = this.po) === null || _a === void 0 ? void 0 : _a.disconnect();
  };
  /* Send API data, not be affected by path filter config  */
  APIPlugin.prototype.sendData = function (data) {
    if (typeof this.triggerHandler !== 'function') {
      log_1.Logger.info('[MDAP] API Plugin is inactive');
      return;
    }
    if (!data.url) {
      log_1.Logger.info('[MDAP] URL cannot be empty');
      return;
    }
    if (typeof data.duration !== 'number') {
      log_1.Logger.info('[MDAP] duration should be a number');
      return;
    }
    var defaultValue = {
      http_method: 'GET',
      http_status_code: 200,
      logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
      end_timestamp: +new Date(),
      start_timestamp: +new Date() - data.duration
    };
    this.triggerHandler(__assign(__assign({}, defaultValue), data));
  };
  APIPlugin.TRIGGER_MAPS = {};
  APIPlugin.filled = false;
  return APIPlugin;
}(javascript_sdk_1.BasePlugin);
exports.default = APIPlugin;